<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <input type="text" value="" v-model="internalValue" :placeholder="placeholder" :readonly="readOnly"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','suffix','lang','required','readonly'],
        data: function () {
            return {
                internalValue: '',
                langClass:""
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Text.vue